export enum CourseCardType {
    CLASSROOM_COURSE = 'classroom_course',
    DIGITAL_COURSE = 'digital_course', 
    YOUTH_COURSE = 'youth_course'
}